import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SIGN_IN_PATH } from "utils/auth/signInPath";

const HOME_PATH = "/";

/**
 * Where a successful sign-in lands: the in-app location RequireSession put in
 * `state.from`, else home. Anything that is not a same-origin path (absolute
 * or protocol-relative URL, a backslash host, the sign-in page itself, a
 * non-string) falls back to home.
 */
export const returnPathAfterSignIn = (state: unknown): string => {
  const from = (state as { from?: unknown } | null | undefined)?.from as
    | { pathname?: unknown; search?: unknown; hash?: unknown }
    | undefined;
  const pathname = from?.pathname;
  if (
    typeof pathname !== "string" ||
    !pathname.startsWith("/") ||
    pathname.startsWith("//") ||
    pathname.startsWith("/\\") ||
    pathname === SIGN_IN_PATH
  ) {
    return HOME_PATH;
  }
  const search = typeof from?.search === "string" ? from.search : "";
  const hash = typeof from?.hash === "string" ? from.hash : "";
  return `${pathname}${search}${hash}`;
};

/**
 * THE success exit of every sign-in flow (email OTP, Google, Telegram): go
 * back to the deep link that required the session, else home.
 */
export const useReturnAfterSignIn = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  return useCallback(() => navigate(returnPathAfterSignIn(state)), [navigate, state]);
};
